<template>
  <section class="container section pt-5">
    <div class="title is 3">
      {{ $t("billing information") }}
    </div>
    <div class="form">
      <div class="title is-5">{{ $t("order for") }} {{ order.name }}</div>
      <div class="columns">
        <!-- <div class="column">
          <div class="field">
            <label class="label">{{ $t("amount") }}</label>
            <div class="control has-icons-left has-icons-right">
              <input
                class="input is-medium"
                type="text"
                v-model="meta.amount"
              />
              <span class="icon is-left">
                <i class="fa fa-credit-card"></i>
              </span>
            </div>
          </div>
        </div> -->
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("nit") }}</label>
            <div class="control">
              <input type="text" class="input" v-model="meta.billing_nit" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input type="text" class="input" v-model="meta.billing_name" />
            </div>
          </div>
        </div>
      </div>
      <article class="message is-info">
        <div class="message-body">
          <div class="content">
            {{ $t("billing will be sent to you over email") }}
          </div>
        </div>
      </article>
      <article class="message is-success" v-show="success && false">
        <div class="message-header">
          <p>{{ $t("payment registered") }}</p>
        </div>
        <div class="message-body">
          {{ $t("your payment has been registered") }}
        </div>
      </article>
      <div class="field">
        <div class="control">
          <button
            class="button is-rounded is-primary"
            @click="save"
            :disabled="is_invalid"
          >
            <span class="icon">
              <i class="fa fa-save"></i>
            </span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- <pre>{{ meta }}{{ order }}</pre> -->
  </section>
</template>

<script>
import {
  get,
  post,
  put,
  error_message,
  format_currency,
  success_message,
} from "@/utils";
import moment from "moment";

export default {
  name: "TailoringOrderBilling",
  components: {},
  computed: {
    is_invalid() {
      let v = this;
      // return false;
      return !v.meta.billing_name || !v.meta.billing_nit;
    },
  },
  data() {
    return {
      order: {},
      success: false,
      meta: {
        billing_name: "",
        billing_nit: "",
      },
    };
  },
  methods: {
    save() {
      let v = this;
      v.$root.loader(true);
      put("/tailoring_order/link/billing", {
        uuid: v.$route.params.id,
        ...v.meta,
      })
        .then((response) => {
          v.success = true;
          success_message(v.$t("billing information registered"));
          v.meta = {
            billing_name: "",
            billing_nit: "",
          };
          setTimeout(() => {
            if (v.$route.params.url) {
              v.$router.push({
                path: `/tailoring_order/order/${v.$route.params.url}`,
              });
            } else {
              v.$router.push({
                path: `/tailoring_order/order/${v.order.source.url_name}`,
              });
            }
          }, 2000);
        })
        .catch((error) => {
          error_message(error);
          console.error(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
  },
  mounted() {
    let v = this;
    let uuid = v.$route.params.id;
    get("/tailoring_order/link/order", { uuid })
      .then((response) => {
        v.order = response;
        if (response && response.total) v.meta.amount = response.total;
        if (
          response &&
          response.settings &&
          response.settings.billing_name &&
          response.settings.billing_nit
        ) {
          v.meta.billing_name = response.settings.billing_name;
          v.meta.billing_nit = response.settings.billing_nit;
        }
      })
      .catch((error) => {
        error_message(error);
        console.error(error);
      });
  },
  created() {},
};
</script>

<style scoped></style>
